<template>
  <Alert type="warning">
    <template v-if="error === 'HasNoReverseDnsRecord'">
      IP addresses can't have any DNS records attached to them. We tried to find the hostname of this IP address with
      a reverse DNS lookup, and show the DNS records for that instead. However, the IP address <b>{{ domain }}</b> has no reverse DNS
      record.
    </template>
    <template v-else-if="error === 'InvalidDomain'">
      <b>{{ domain }}</b> is not a valid domain name. For example, try <dns-records-link domain="wikipedia.org" class="font-semibold hover:underline" /> or
      <dns-records-link domain="www.twitter.com" class="font-semibold hover:underline" /> to view their DNS records.
    </template>
    <template v-else-if="error === 'DnsQueryFailed'">
      One or more DNS queries failed while looking up DNS records for <b>{{ domain }}</b>. Please try again.
    </template>
    <template v-else-if="error === 'NoDnsServersAvailable'">
      <p v-if="dnsServers[dnsserver].type === 'local'">None of the DNS server in {{ dnsServers[dnsserver].pretty }} are available.
        Please try again another DNS server by selecting it above.</p>
      <p v-else-if="dnsServers[dnsserver].type === 'popular'">None of the {{ dnsServers[dnsserver].pretty }} DNS servers are available.
        Please try again another DNS server by selecting it above.</p>
      <p v-else>None of the authoritative DNS servers are available.
        Please try again another DNS server by selecting it above.</p>
    </template>
    <template v-else>
      Nslookup was unable to find DNS records for <b>{{ domain }}</b>.
    </template>
  </Alert>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import Alert from '@/components/micro/AlertComponent.vue';
import { dnsServers } from '@/common/dnsServers';
import { ApiErrorType } from '@/model/ApiErrorAlert';

defineProps({
  error: {
    type: String as PropType<ApiErrorType>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
  dnsserver: {
    type: String,
    required: true,
  },
});
</script>
